// List, create, update, and delete proforma claims.
import axios from "axios";
import jsonFormData from "json-form-data";

const prepareData = (data) => {
  return jsonFormData({ administration_proforma_claim: data }, { showLeafArrayIndexes: true });
};

export const GET_ADMINISTRATION_PROFORMA_CLAIMS = "get_administration_proforma_claims";
export const getAdministrationProformaClaims = (month, monthBy, projectId) => {
  const url = `/administration/proforma_claims.json`;
  const params = {};
  if (month) params.month = month;
  if (month && monthBy) params.month_by = monthBy;
  if (projectId) params.project_id = projectId;
  const request = axios.get(url, { params });
  return {
    type: GET_ADMINISTRATION_PROFORMA_CLAIMS,
    payload: request,
  };
};

export const CREATE_ADMINISTRATION_PROFORMA_CLAIM = "create_administration_proforma_claim";
export const createAdministrationProformaClaim = (data) => {
  const url = `/administration/proforma_claims.json`;
  const request = axios({ method: "post", url: url, data: prepareData(data) });
  return {
    type: CREATE_ADMINISTRATION_PROFORMA_CLAIM,
    payload: request,
  };
};

export const GET_ADMINISTRATION_PROFORMA_CLAIM = "get_administration_proforma_claim";
export const getAdministrationProformaClaim = (id) => {
  const url = `/administration/proforma_claims/${id}.json`;
  const request = axios.get(url);
  return {
    type: GET_ADMINISTRATION_PROFORMA_CLAIM,
    payload: request,
  };
};

export const UPDATE_ADMINISTRATION_PROFORMA_CLAIM = "update_administration_proforma_claim";
export const updateAdministrationProformaClaim = (id, data) => {
  const url = `/administration/proforma_claims/${id}.json`;
  const request = axios({ method: "patch", url: url, data: prepareData(data) });
  return {
    type: UPDATE_ADMINISTRATION_PROFORMA_CLAIM,
    payload: request,
  };
};

export const DESTROY_ADMINISTRATION_PROFORMA_CLAIM = "destroy_administration_proforma_claim";
export const destroyAdministrationProformaClaim = (id) => {
  const url = `/administration/proforma_claims/${id}.json`;
  const request = axios({ method: "delete", url: url });
  return {
    type: DESTROY_ADMINISTRATION_PROFORMA_CLAIM,
    payload: request,
  };
};

export const LINK_ADMINISTRATION_PROFORMA_CLAIM_INVOICE = "link_administration_proforma_claim_invoice";
export const linkProformaClaimInvoice = (id, invoiceNumber) => {
  const request = axios.post(`/administration/proforma_claims/${id}/link_invoice.json`, { invoice_number: invoiceNumber });
  return {
    type: LINK_ADMINISTRATION_PROFORMA_CLAIM_INVOICE,
    payload: request,
  };
};

export const CREATE_ADMINISTRATION_PROFORMA_CLAIM_INVOICE = "create_administration_proforma_claim_invoice";
export const createProformaClaimInvoice = (id, data) => {
  const request = axios.post(`/administration/proforma_claims/${id}/create_invoice.json`, data);
  return {
    type: CREATE_ADMINISTRATION_PROFORMA_CLAIM_INVOICE,
    payload: request,
  };
};

export const getNextProformaClaimNumber = (projectId) => {
  return axios.get(`/administration/proforma_claims/next_number.json`, { params: { project_id: projectId } });
};

// A normal link does not send the login token, so Rails would bounce the download to sign-in.
export const downloadProformaSheet = (params) => {
  return axios.get("/administration/proforma_claims/export", { params, responseType: "blob" }).then((response) => {
    const type = response.data?.type || "";
    if (type.includes("text/html")) {
      return Promise.reject(new Error("Could not download the spreadsheet."));
    }

    const header = response.headers["content-disposition"] || "";
    const match = /filename="([^"]+)"/.exec(header);
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = match ? match[1] : "MJH Engineering.xls";
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  });
};

export const proformaClaimErrorMessage = (error) => {
  const data = error?.response?.data;
  if (!_.isPlainObject(data)) return "Could not save proforma claim";

  return _.flatMap(data, (messages, key) => _.castArray(messages).map((message) => `${_.startCase(key)} ${message}`)).join(". ");
};
